module.exports = __webpack_public_path__ + "static/banner-2-music-teacher-c95a5b069cd1933933721c865e498318.jpg";